import './index.css';
// Navbar shell in critical path — must not wait on a lazy layout chunk.
import './components/header/navbar/Navbar.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { observeLCP } from './perf/lcp-observer';
import { HelmetProvider } from 'react-helmet-async';
import { bindUnauthorizedHandler } from './services/authSession';
import { sessionExpired } from './store/features/auth/authSlice';

bindUnauthorizedHandler(() => {
  store.dispatch(sessionExpired());
});

const rootEl = document.getElementById('root')!;
const root = createRoot(rootEl);

observeLCP();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);
